export const ExpandLessIcon = () => {
    return (
        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M0.121094 16.4409C0.121094 25.5198 7.48217 32.8809 16.5611 32.8809C25.64 32.8809 33.0011 25.5198 33.0011 16.4409C33.0011 7.36194 25.64 0.000863772 16.5611 0.000863772C7.48217 0.000863772 0.121094 7.36194 0.121094 16.4409ZM9.43816 20.8452V15.9325L16.5611 10.7575L23.6867 15.9298V20.8452L16.5611 15.6729L9.43816 20.8452Z" fill="#142440" />
        </svg>

    )
}
